import { PersonPreview } from '@/components/controls';
import { useGroups, useUser } from '@/hooks';
import { listGroupLabels } from '@/utils';
import {
  Link as LinkIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  ImageListItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { formatDistanceToNow } from 'date-fns';

export function Notice({ notice, onSettingsClick }) {
  const { data: user } = useUser(notice.edited.userCode);
  const { data: groups } = useGroups({ types: ['SECTOR', 'TEAM'] });

  return (
    <Card variant="outlined" sx={{ flexGrow: 1, display: 'flex' }}>
      <PersonPreview code={notice.personCode} />
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Stack>
            <Stack direction="row" spacing={1} justifyContent="space-between">
              <Typography variant="caption" color="text.secondary" gutterBottom>
                {user
                  ? `${user.name} - ${formatDistanceToNow(
                      new Date(notice.edited.time),
                    )} ago`
                  : '-'}
              </Typography>
              <Typography variant="caption" color="text.secondary" gutterBottom>
                {!!notice && !!groups
                  ? `${listGroupLabels('Group', notice.groupCodes, groups)}`
                  : ''}
              </Typography>
            </Stack>
            <Typography sx={{ whiteSpace: 'pre-wrap' }} gutterBottom>
              {notice.message}
            </Typography>
          </Stack>
        </CardContent>
        <CardActions>
          {!!notice.linkHref && (
            <Tooltip title="Link">
              <IconButton size="small" href={notice.linkHref} target="_blank">
                <LinkIcon />
              </IconButton>
            </Tooltip>
          )}
          <Box sx={{ flexGrow: 1 }} />
          <Tooltip title="Settings">
            <IconButton size="small" onClick={onSettingsClick}>
              <SettingsIcon />
            </IconButton>
          </Tooltip>
        </CardActions>
      </Box>
      {!!notice.imageSrc && (
        <ImageListItem>
          <CardMedia
            component="img"
            sx={{ maxWidth: 240 }}
            image={notice.imageSrc}
          />
        </ImageListItem>
      )}
    </Card>
  );
}
